<!-- 批量修改 -->
<template>
  <div class="createBatchProducts">
    <div>
      <el-steps :active="active" align-center>
        <el-step title="1.下载商品模板">
          <i class="step01" slot="icon"></i>
        </el-step>
        <el-step title="2.上传数据表">
          <i class="step02" slot="icon"></i>
        </el-step>
        <el-step title="3.维护图片/可售区域">
          <i class="step03" slot="icon"></i>
        </el-step>
        <el-step title="4.提交审核">
          <i class="step04" slot="icon"></i>
        </el-step>
        <el-step title="5.完成">
          <i class="step05" slot="icon"></i>
        </el-step>
      </el-steps>
    </div>
    <div
      class="my-content-box"
      v-loading="uploadLoading"
      element-loading-text="文件上传中，请耐心等待"
    >
      <!-- 
        class="e-content" 
        这个后期抽离出去
      -->
      <div class="e-content" v-if="!succeedVisible">
        <h3 style="line-height: 1;">上传文件：</h3>
        <div class="salesScope" style="line-height: 1;">
          <div class="name">
            <span>销售范围：</span>
            <el-tooltip
              effect="dark"
              content="Right Center 提示文字"
              placement="right"
              class="my-tooltip"
            >
              <div slot="content">
                <p>销售范围：是指您的商品对全平台客户的销售范围；</p>
                <p>全平台：表示对平台所有客户销售；</p>
                <p>仅协议客户：表示对您设置的平台协议客户，以协议价销售；</p>
              </div>
              <div class="salesScope-icon">?</div>
            </el-tooltip>
          </div>
          <el-radio-group v-model="salesScope">
            <el-radio :label="1">向全平台销售</el-radio>
            <el-radio :label="2">向仅协议客户销售</el-radio>
          </el-radio-group>
        </div>
        <div class="upload-content">
          <div class="upload-btn">
            <el-upload
              ref="uploadFile"
              class="upload-demo"
              :http-request="uploadFile"
              :file-list="fileList"
              :auto-upload="false"
              :on-change="onChange"
              :on-success="handleFileSuccess"
              :before-remove="beforeRemove"
              :on-remove="handleRemove"
              :headers="headers"
              name="fileList"
              action
              :limit="limit"
              accept=".xlsx, xls"
            >
              <el-button class="choose-btn" size="small" type="primary"
                >选择文件</el-button
              >
              <div slot="tip" class="el-upload__tip" v-if="ifSubmit">
                请先
                <span class="link" @click="openDowloadTempDialog"
                  >下载商品上线模板</span
                >
                ，如何使用，可查看
                <span class="link" @click="linkView">视频教程</span>
              </div>
            </el-upload>
          </div>
          <div class="upload-tips">
            <div>
              <i class="el-icon-warning-outline"></i>
            </div>
            <div>
              <p>温馨提示：</p>
              <p>
                1.
                可上传多个excel表格，excel格式支持xlsx或xls，属性条数≤10000条。
              </p>
              <p>
                2. 必填字段不能为空（必填字段名称前面带*），否则将导入失败。
              </p>
              <p>
                3.
                商品模板中品牌、税率、计量单位、属性值填写，请参考模板页签“分类说明”中的选项值。
              </p>
            </div>
          </div>
          <div class="upload-btn-import">
            <el-button
              class="return-product"
              icon="el-icon-arrow-left"
              @click="goToUrl('/createProduct')"
            >
              返回
            </el-button>
            <el-button @click="submitUpload" type="primary" :disabled="ifSubmit"
              >上 传</el-button
            >
          </div>
        </div>
      </div>

      <!-- 
        上传完成/成功和失败
      -->
      <div class="data-ok" v-if="succeedVisible">
        <!-- <el-alert title="数据上传完成" type="success" show-icon></el-alert> -->
        <h3>上传完成：</h3>
        <div class="alert">
          <i class="el-icon-circle-check" v-if="isFail"></i>
          <i class="el-icon-circle-close" v-if="!isFail"></i>
          <span v-if="isFail">商品数据上传完毕</span>
          <span v-if="!isFail">商品数据上传失败</span>
        </div>
        <ul class="xlsx-list">
          <li
            class="item"
            v-for="(item, index) of currentTableHistoryData"
            :key="index"
          >
            <div>
              <i class="el-icon-document"></i>
              {{ item.fileName }}
            </div>
            <div>
              <p>
                {{ `成功上传${item.successNumber}条，` }} 失败
                <span>{{ item.failNumber }}</span>
                条
              </p>
            </div>
            <div>
              <el-button
                v-if="item.failNumber !== 0"
                type="text"
                @click="downloadFile(item)"
              >
                下载错误数据
              </el-button>
            </div>
          </li>
        </ul>
        <div class="data-btn">
          <el-button type="primary" @click="handleContinueUpload"
            >继续批量上传</el-button
          >
          <el-button type="primary" @click="goToUrl('/createProduct')"
            >维护商品图片</el-button
          >
        </div>
      </div>
      <!-- 商品上传失败 -->
      <!-- <div v-else class="data-ok">
        <h3>上传完成：</h3>
        <div class="alert">
          <i class="el-icon-circle-close"></i>
          <span>商品数据上传失败</span>
        </div>
        <div class="data-btn">
          <el-button type="primary" @click="handleContinueUpload">继续批量上传</el-button>
          <el-button type="primary" @click="goToUrl('/createProduct')">维护商品图片</el-button>
        </div>
      </div> -->

      <!-- 
        历史信息
        后期抽离出去
      -->
      <div>
        <div class="upload-history" ref="uploadHistory">
          <div>上传历史</div>
          <div @click="tableHistoryShwo">
            <i class="el-icon-arrow-up" v-show="iocnShow"></i>
            <i class="el-icon-arrow-down" v-show="!iocnShow"></i>
          </div>
        </div>
        <div class="table-content" v-show="tableShow">
          <!-- 列表 -->
          <el-table :data="tableHistoryData" border ref="tableData">
            <el-table-column fixed label="序号" width="60" align="center">
              <template slot-scope="scope">
                <span>{{
                  (listQuery.pageNum - 1) * listQuery.pageSize +
                    scope.$index +
                    1
                }}</span>
              </template>
            </el-table-column>
            <el-table-column min-width="180" label="文件名称" align="center">
              <template slot-scope="scope">{{ scope.row.fileName }}</template>
            </el-table-column>
            <el-table-column min-width="80" label="处理数量" align="center">
              <template slot-scope="scope">{{
                scope.row.totalNumber
              }}</template>
            </el-table-column>
            <el-table-column min-width="80" label="处理成功数量" align="center">
              <template slot-scope="scope">{{
                scope.row.successNumber
              }}</template>
            </el-table-column>
            <el-table-column min-width="80" label="处理失败数量" align="center">
              <template slot-scope="scope">
                <span class="error">{{ scope.row.failNumber }}</span>
              </template>
            </el-table-column>
            <el-table-column min-width="150" label="创建时间" align="center">
              <template slot-scope="scope">{{ scope.row.createTime }}</template>
            </el-table-column>
            <!-- <el-table-column min-width="80" label="操作人">
              <template slot-scope="scope"> </template>
            </el-table-column>-->
            <el-table-column
              label="操作"
              width="60px"
              fixed="right"
              align="center"
            >
              <template slot-scope="scope">
                <el-button type="text" @click="downloadFile(scope.row)"
                  >下载</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-box">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, prev, pager, next, jumper"
              :current-page="listQuery.pageNum"
              :total="total"
              :small="true"
              :page-size.sync="listQuery.pageSize"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="选择商品模板"
      :visible.sync="dialogFormVisible"
      width="1000px"
      :before-close="cancelHandle"
      :append-to-body="true"
      class="createBatchProducts-dialog"
    >
      <el-form
        :inline="true"
        :model="categoryQuery"
        ref="categorySearchQuery"
        class="search-form"
      >
        <el-form-item label="末级分类编号：">
          <el-input
            v-model="categoryQuery.categoryCode"
            placeholder="请输入末级分类编号"
            @input="getCategoryCode"
          ></el-input>
        </el-form-item>
        <el-form-item label="末级分类名称：">
          <el-input
            v-model="categoryQuery.categoryName"
            placeholder="请输入末级分类名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="categorySearch">查询</el-button>
          <el-button @click="categoryReset">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="categoryLeafList"
        border
        height="320"
        v-loading="categoryLoading"
      >
        <el-table-column label width="40">
          <template slot-scope="scope">
            <el-radio
              :label="scope.$index"
              v-model="currentRow"
              @change.native="getCurrentRow(scope.row)"
            ></el-radio>
          </template>
        </el-table-column>
        <el-table-column
          prop="categoryCode"
          label="末级分类编码"
          min-width="100"
        >
          <!-- <template slot-scope="scope">
            <span v-if="scope.row.categoryCode">{{ scope.row.categoryCode }}</span>
            <span v-if="scope.row.mdmCode">{{ scope.row.mdmCode }}</span>
          </template>-->
        </el-table-column>
        <el-table-column
          prop="categoryName"
          label="末级分类名称"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="categoryNavigationPath"
          label="所属分类"
          min-width="160"
        ></el-table-column>
      </el-table>
      <!--           :page-sizes="[10, 20, 30]" -->
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChangeCat"
          @current-change="handleCurrentChangeCat"
          layout="total, prev, pager, next, jumper"
          :current-page="categoryQuery.pageNum"
          :total="categoryListTotal"
          :page-size.sync="categoryQuery.pageSize"
        ></el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelHandle">取 消</el-button>
        <el-button
          type="primary"
          @click="downloadTmp"
          :disabled="dowloadLoad"
          :loading="dowloadLoad"
        >
          下载模版
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import utils from '../../../utils/utils';
import api from '../../../api/product';
import { epecToken } from '../../../utils/globalData';
import apiLogin from '@/modules/projectA/api/login/index';
import { epecMallUrl } from '@/modules/projectA/api/config';
export default {
  data() {
    return {
      currentRow: -1,
      categoryQuery: { pageNum: 1, pageSize: 10 },
      categoryListTotal: 0,
      dowloadRow: {},
      categoryList: [],
      dowloadLoad: false,
      categoryLoading: false,
      // -------------------------------------
      // 展示上传成功列表
      succeedVisible: false,
      // 上传加载loading
      uploadLoading: false,
      // 是否展示上传历史信息
      tableShow: false,
      // 成功之后展示的icon
      iocnShow: false,
      // 上传完成之后后台返回的当前上传数据
      currentTableHistoryData: [],
      tableHistoryData: [],
      tableData: [],
      listQuery: {
        pageNum: 1,
        pageSize: 10
      },
      cloneListQuery: {},
      total: 0,
      ifSubmit: true,
      active: 5,
      // 请求头信息
      headers: epecToken,
      // 上传文件的数量
      limit: 10,
      // 上传的文件列表,文件编辑回显的时候用到
      fileList: [],
      // 限制文件上传的大小
      fileSize: 5,
      dialogFormVisible: false,
      selectOptions: [],
      value: '',
      downloadQuery: {},
      clickableUpload: false,
      rules: {
        categoryId: [
          { required: true, message: '请选择分类名称', trigger: 'change' }
        ]
      },
      classifyForm: {
        categoryId: ''
      },
      salesScope: 1,
      categoryLeafList: [],
      isFail: false,
      getLoginFront: null,
      getLoginRear: null
    };
  },
  /* computed: {
    isFail() {
      const failArr = this.currentTableHistoryData.filter(item => {
        return item.failNumber !== 0;
      });
      return failArr.length === 0;
    },
  }, */
  created() {
    const { cloneDeep } = utils;
    this.cloneListQuery = cloneDeep(this.listQuery);
    this.getHistoryList(this.listQuery);
    // this.getQueryCompanyCategoryLeafListByPage(this.categoryQuery);
    // this.getQueryLeafCategoryListByPage(this.categoryQuery);
  },
  mounted() {
    //开启延长登录
    this.getLoginActive();
  },
  methods: {
    getCategoryCode(event) {
      this.categoryQuery.categoryCode = event.replace(/^(0+)|[^\d]+/g, '');
    },
    linkView() {
      window.open(`${epecMallUrl}/eCourse/detail?lessonId=18&categoryId=7`);
    },
    openDowloadTempDialog() {
      this.currentRow = -1;
      this.categoryListTotal = 0;
      this.categoryLeafList = [];
      this.dialogFormVisible = true;
      // this.$refs.categorySearchQuery.resetFields();
      if (this.salesScope === 2) {
        this.getQueryLeafCategoryListByPage(this.categoryQuery);
      } else {
        this.getQueryCompanyCategoryLeafListByPage(this.categoryQuery);
      }
    },
    getCurrentRow(row) {
      console.log(row);
      this.dowloadRow = { ...row };
    },
    categorySearch() {
      this.currentRow = -1;
      this.categoryQuery.pageNum = 1;
      if (this.salesScope === 2) {
        this.getQueryLeafCategoryListByPage(this.categoryQuery);
      } else {
        this.getQueryCompanyCategoryLeafListByPage(this.categoryQuery);
      }
    },
    categoryReset() {
      this.currentRow = -1;
      this.categoryQuery = {
        pageNum: 1,
        pageSize: 10
      };
      if (this.salesScope === 2) {
        this.getQueryLeafCategoryListByPage(this.categoryQuery);
      } else {
        this.getQueryCompanyCategoryLeafListByPage(this.categoryQuery);
      }
    },
    handleCurrentChangeCat(val) {
      this.currentRow = -1;
      this.categoryQuery.pageNum = val;
      if (this.salesScope === 2) {
        this.getQueryLeafCategoryListByPage(this.categoryQuery);
      } else {
        this.getQueryCompanyCategoryLeafListByPage(this.categoryQuery);
      }
    },
    handleSizeChangeCat(val) {
      this.currentRow = -1;
      this.categoryQuery.pageNum = 1;
      this.categoryQuery.pageSize = val;
      if (this.salesScope === 2) {
        this.getQueryLeafCategoryListByPage(this.categoryQuery);
      } else {
        this.getQueryCompanyCategoryLeafListByPage(this.categoryQuery);
      }
    },
    // 获取末级类目-协议用户
    async getQueryLeafCategoryListByPage(params) {
      const { queryLeafCategoryListByPage } = api;
      this.categoryLoading = true;
      const res = await queryLeafCategoryListByPage(params);
      this.categoryLoading = false;
      if (res.code === '200') {
        const data = res.data;
        console.log(res);
        this.categoryLeafList = [...data.records];
        this.categoryListTotal = data.total;
      }
    },
    // 获取商品下载分类名称列表-全品台
    async getQueryCompanyCategoryLeafListByPage(params) {
      const { queryCompanyCategoryLeafListByPage } = api;
      this.categoryLoading = true;
      const res = await queryCompanyCategoryLeafListByPage(params);
      this.categoryLoading = false;
      const data = res.data;
      console.log(res);
      this.categoryLeafList = [...data.records];
      console.log(this.categoryLeafList);
      this.categoryListTotal = data.total;
    },
    // 跳转链接
    goToUrl(url) {
      this.$router.push({ path: url });
    },
    async getHistoryList(params) {
      try {
        await api.selectSkuImportFilePage(params).then(res => {
          if (res.code === '200') {
            const data = res.data;
            this.tableHistoryData = [...data.records];
            this.total = data.total;
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    // 继续下载按钮操作
    handleContinueUpload() {
      this.succeedVisible = false;
    },
    // 处理历史列表
    tableHistoryShwo() {
      this.tableShow = !this.tableShow;
      this.iocnShow = !this.iocnShow;
      this.tableShow
        ? (this.$refs.uploadHistory.style['border-bottom'] = 'none')
        : (this.$refs.uploadHistory.style['border-bottom'] = '1px solid #ccc');

      this.$refs.uploadHistory;
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getHistoryList(this.listQuery);
    },
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getHistoryList(this.listQuery);
    },
    selectChange(value) {
      if (this.salesScope === 2) {
        const [selectParam] = this.selectOptions.filter(
          item => item.categoryId === value
        );
        this.downloadQuery = { ...selectParam };
      } else {
        const [selectParam] = this.categoryLeafList.filter(
          item => item.categoryId === value
        );
        console.log(selectParam);
        this.downloadQuery = { ...selectParam };
      }
    },
    cancelHandle() {
      // this.$refs.classifyForm.resetFields();
      this.categoryListTotal = 0;
      this.categoryLeafList = [];
      this.categoryQuery = { pageNum: 1, pageSize: 10 };
      this.dialogFormVisible = false;
      this.currentRow = -1;
      this.dowloadRow = {};
      this.$refs.categorySearchQuery.resetFields();
    },
    // 下载模版
    async downloadTmp() {
      console.log(this.currentRow);
      if (this.currentRow < 0) {
        this.$message({
          message: `请选择列表数据`,
          type: 'warning'
        });
        return;
      }
      console.log(this.dowloadRow);
      try {
        console.log(this.downloadQuery);
        const { categoryId, categoryName } = this.dowloadRow;
        this.dowloadLoad = true;
        const res = await api.downSkuUploadTemplate({
          categoryId,
          categoryName
        });
        // console.log(res)
        this.dowloadLoad = false;
        if (res.size !== 0) {
          utils.downFile(res, `${categoryName}导入模板`);
          this.dialogFormVisible = false;
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 上传文件提交
    submitUpload() {
      if (!this.salesScope) {
        this.$message({
          message: `请选择销售范围!`,
          type: 'warning'
        });
        return;
      }
      // 通过 FormData 对象上传文件
      const fileList = new FormData();
      // 执行文件上传的函数，其实也就是调用 uploadFile方法 来获取我们要上传的文件
      this.$refs.uploadFile.submit();
      this.fileList.forEach(file => {
        // 因为要上传多个文件，所以需要遍历
        fileList.append('fileList', file, file.name);
        // 以formData 的方式传参数
        fileList.append('salesScope', this.salesScope);
      });
      this.uploadLoading = true;
      api
        .importSkuTemplate(fileList)
        .then(res => {
          if (res.code === '200') {
            const data = res.data;
            this.currentTableHistoryData = [...data];

            const failArr = data.filter(item => {
              return item.successNumber !== 0;
            });
            this.isFail = failArr.length !== 0;
          } else {
            this.isFail = false;
            this.currentTableHistoryData = [];
          }
        })
        .finally(() => {
          this.succeedVisible = true;
          this.uploadLoading = false;
          this.fileList = [];
          this.ifSubmit = true;
          this.$refs.uploadFile.clearFiles();
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 下载失败的文件
    async downloadFile(row) {
      const { categoryId, fileId, fileName } = row;
      const errFliezName = fileName.substring(0, fileName.length - 5);
      const { downSkuUploadErrorMessage } = api;
      const res = await downSkuUploadErrorMessage({ categoryId, fileId });
      if (res.size !== 0) {
        utils.downFile(res, `${errFliezName}错误文件`);
      }
    },

    // 文件fliesize及格式校验
    isFileSize(file) {
      if (file.size / 1024 / 1024 > this.fileSize) {
        this.$message({
          message: `请上传小于${this.fileSize}M的文件!`,
          type: 'error'
        });
        return false;
      }
      /* if (file.name.includes(",")) {
        this.$message({
          message: "文件名格式错误!",
          type: "error",
        });
        return false;
      } */
      return true;
    },
    // 以下是上传文件需要的方法
    commonHandleCheck(val) {
      let testmsg = val.substring(val.lastIndexOf('.') + 1);
      testmsg && (testmsg = testmsg.toLowerCase());
      return testmsg;
    },

    // 验证调删除事件时的文件规则
    fileFormat(file) {
      let testmsg = this.commonHandleCheck(file.name);
      const isXls = testmsg === 'xls';
      const isXlsx = testmsg === 'xlsx';
      return isXls || isXlsx;
    },
    // 改变文件的钩子
    onChange(file, fileList) {
      if (fileList.length !== 0) {
        this.ifSubmit = false;
      }
      let testmsg = this.commonHandleCheck(file.name);
      const isXls = testmsg === 'xls';
      const isXlsx = testmsg === 'xlsx';
      // 避免有些是手动上传文件，直接在on-change上进行文件校验
      if (!isXlsx && !isXls) {
        this.$message({
          message: '上传文件只能是xlsx、xls格式!',
          type: 'error'
        });
        fileList.length && this.$refs.uploadFile.clearFiles();
        return false;
      }
      if (!this.isFileSize(file)) {
        this.$message({
          message: `上传文件大小不能超过 ${this.fileSize}MB!`,
          type: 'error'
        });
        fileList.length && this.$refs.uploadFile.clearFiles();
        return false;
      }
      console.log('改变文件的钩子', fileList);
      // 只能上传excel
      return isXlsx || isXls;
    },
    // 上传成功的钩子
    handleFileSuccess(response, file, fileList) {
      this.$refs.uploadFile.clearFiles();
      // 不管成功还是失败都将弹窗中选择的文件清空
      for (let index = 0; index < fileList.length; index++) {
        fileList.splice(index, 1);
      }
      this.fileList = [];
      this.ifSubmit = true;
      console.log(file, fileList, '上传成功的钩子111');
    },
    // 移除前的钩子
    beforeRemove(file) {
      console.log(file, '移除前的钩子');
      if (this.fileFormat(file)) {
        // 删除提示
        return this.$confirm(`确定永久移除 ${file.name}？`, '提示');
      }
    },
    // 上传失败的钩子
    errFunction(file, fileList) {
      console.log(file, fileList);
      this.$message.error('上传失败');
    },
    // 移除的钩子
    handleRemove(file, fileList) {
      console.log(file, fileList);
      // 由于elemenUI上传文件之间的校验返回false就会触发删除事件
      console.log(file, fileList);
      if (fileList.length === 0) {
        this.ifSubmit = true;
      }
    },
    // 这里就是的到需要上传文件的集合
    uploadFile(params) {
      this.fileList.push(params.file);
    },
    //心跳延长登录时间
    async getLoginActive() {
      clearInterval(this.getLoginRear);
      clearTimeout(this.getLoginFront);
      this.refreshRear();
      this.refreshFront();
    },

    async refreshRear() {
      this.getLoginFront = setInterval(async () => {
        console.log(new Date().getTime());
        await apiLogin.getLoginInfo();
      }, 600000);
    },

    async refreshFront() {
      let token = this.$cookies.get('epecToken');
      if (token) {
        let epecTokenExpiredTime = this.$cookies.get('epecTokenExpiredTime');
        let now = new Date().getTime();
        let time = epecTokenExpiredTime;
        let timeOutIn = null;
        let timeOut = null;
        if (time > now) {
          let interval = time - now;
          timeOut = interval - 30000;
        }
        console.log(time);
        console.log(timeOut);
        this.getLoginFront = setTimeout(async () => {
          console.log('更新token', new Date().getTime());
          await apiLogin.getLoginInfo().then(res => {
            this.refreshFront();
          });
        }, timeOut);
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.getLoginRear);
    clearTimeout(this.getLoginFront);
  }
};
</script>
<style lang="scss">
.createBatchProducts-dialog {
  .el-table__row .cell {
    .el-radio {
      .el-radio__label {
        display: none;
      }
    }
  }
  .pagination-box {
    text-align: right;
    margin-top: 20px;
    margin-bottom: 0;
  }
}
</style>
<style lang="scss" scoped>
.createBatchProducts {
  ::v-deep .el-table__row .cell {
    font-size: 12px;
    white-space: normal;
    padding-left: 6px;
    padding-right: 6px;
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2; /*要显示的行数*/
    -webkit-box-orient: vertical;
    .el-link {
      overflow: hidden;
      display: -webkit-box;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2; /*要显示的行数*/
      -webkit-box-orient: vertical;
    }
    .el-radio {
      background: red;
      .el-radio__label {
        display: none;
      }
    }
    .el-button {
      font-size: 12px;
    }
  }
  ::v-deep .el-table--small td,
  ::v-deep .el-table--small th {
    padding: 6px 0;
  }
  ::v-deep .el-dialog__body {
    max-height: 500px;
    overflow: auto;
  }
  .name {
    display: inline-block;
    line-height: 1;
  }
  .my-tooltip {
    display: inline-block;
  }
  .my-content-box {
    width: 100%;
    background: #fff;
    padding: 20px;
  }
  .pagination-box {
    text-align: right;
    margin-top: 20px;
    margin-bottom: 0;
  }
  .e-content {
    width: 100%;
    background: #fff;
    margin-bottom: 20px;
    .salesScope {
      line-height: 1;
      margin: 22px 0;
      .salesScope-icon {
        height: 18px;
        width: 18px;
        border-radius: 50%;
        border: 1px solid #c5c5c5;
        text-align: center;
        line-height: 18px;
        font-size: 12px;
        color: #c5c5c5;
        margin: 0 20px 0 10px;
        cursor: pointer;
        &:hover {
          background: #c5c5c5;
          color: #fff;
        }
      }
    }
    ::v-deep .choose-btn {
      width: 80px;
      height: 30px;
      line-height: 30px;
      padding: 0;
      color: #fff;
      font-size: 14px;
    }
    .upload-tips {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      background: #f4f7ff;
      padding: 20px 10px;
      .el-icon-warning-outline {
        margin-right: 10px;
        color: #2587ff;
        font-size: 18px;
      }
      p {
        font-size: 12px;
        color: #606266;
        margin-top: 10px;
      }
      p:first-child {
        margin-top: 0;
      }
    }
  }
  .upload-content {
    .upload-btn {
      display: flex;
      .el-upload__tip {
        line-height: 1;
        margin: 20px 0;
        font-size: 14px;
        .link {
          color: #2587ff;
          cursor: pointer;
        }
      }
      .upload-demo {
        margin: 0 0 4px 0;
      }
    }
  }
  .upload-history {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    font-size: 14px;
    background: #fff;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    color: #666;
  }
  .upload-btn-import {
    ::v-deep .el-button {
      width: 80px;
      height: 30px;
      padding: 0;
      line-height: 30px;
      margin-left: 0;
    }
    position: relative;
    margin-top: 18px;
    text-align: center;
    .return-product {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .data-ok {
    padding: 18px;
    .alert {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #333333;
      i {
        font-size: 36px;
        margin-right: 20px;
      }
      .el-icon-circle-check {
        color: #50aa43;
      }
      .el-icon-circle-close {
        color: #ef4c56;
      }
    }
    .xlsx-list {
      min-height: 180px;
      max-height: 360px;
      margin: 18px 0;
      overflow: auto;
      .item {
        margin: 8px 0;
        padding: 0 12px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        font-size: 15px;
        color: #2782ec;
        &:nth-child(even) {
          background: #f5f5f5;
        }
        .el-icon-document {
          margin-right: 8px;
        }
        div:nth-of-type(1) {
          flex: 3;
        }
        div:nth-of-type(2) {
          flex: 2;
          color: #666;
          span {
            color: #ef4c56;
          }
        }
        div:nth-of-type(3) {
          flex: 1;
          text-align: right;
          ::v-deep .el-button--text {
            font-size: 15px;
            padding: 0;
          }
        }
      }
    }
    .data-btn {
      text-align: center;
    }
    .error {
      color: red;
    }
  }

  .step01,
  .step02,
  .step03,
  .step04,
  .step05 {
    width: 30px;
    height: 30px;
    background-size: 100% 100%;
  }
  .step01 {
    background-image: url('../../../../../assets/img/icon-fenlei.png');
  }
  .step02 {
    background-image: url('../../../../../assets/img/Union.png');
  }
  .step03 {
    background-image: url('../../../../../assets/img/Vect.png');
  }
  .step04 {
    background-image: url('../../../../../assets/img/Vecto.png');
  }
  .step05 {
    background-image: url('../../../../../assets/img/Vector.png');
  }
  ::v-deep .el-steps {
    width: 100%;
    padding: 0 40px;
    margin-bottom: 20px;
    .el-step.is-horizontal .el-step__line {
      top: 50%;
    }
    .el-step__head.is-process {
      border-color: #dedede;
    }
    .el-step__head.is-finish {
      border-color: #2587ff;
    }
    .el-step__title.is-process {
      color: #dedede;
    }
    .el-step__title.is-finish {
      color: #2587ff;
    }
    .el-step__icon {
      width: 56px;
      height: 56px;
      background: #f0f0f0;
    }
    .el-step__icon.is-text {
      border: none;
    }
  }
  // ::v-deep.el-step__icon.is-text{
  //   border: none;
  // }
  ::v-deep.el-steps .el-step__title.is-finish {
    color: #333333;
  }
}
</style>
